var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8UseAdjustableGuard50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34,33h-3v-3h1c1.105,0,2,0.895,2,2V33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.485,24.929l-2.121,2.121l-2.121-2.121l0.707-0.707c0.781-0.781,2.047-0.781,2.828,0 L31.485,24.929z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 32,
    r: 1,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,30v3h2.471C38.798,32.155,39,31.162,39,30H36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,35v2h22.123l0.12-0.03c0.833-0.208,2.041-0.823,3.032-1.97h-3.419H12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,32c0,0.34-0.02,0.67-0.06,1h-5.08c0.08-0.32,0.14-0.65,0.14-1c0-2.21-1.79-4-4-4s-4,1.79-4,4 c0,0.35,0.06,0.68,0.14,1h-5.08C14.02,32.67,14,32.34,14,32c0-1.41,0.33-2.74,0.91-3.93l10.31-4.8C29.12,24.26,32,27.8,32,32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.822,16.138C32.547,9.094,24.181,6.039,17.138,9.315C10.094,12.591,7.039,20.956,10.315,28 L35.822,16.138z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.5,25.3l-2,0.15c-0.23-3.17-1.23-5.67-1.67-6.65l1.82-0.85C37.16,19.07,38.24,21.8,38.5,25.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "35,25 40,25 37.5,28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,33v-2h-3v1c0,0.366,0.106,0.705,0.277,1H15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8UseAdjustableGuard50);
export default __webpack_public_path__ + "static/media/icons8-use-adjustable-guard-50.4cb377f8168f047fc7851948afa34924.svg";
export { ForwardRef as ReactComponent };